export const CallButton = ({
  onClick,
  className = '',
  disabled = false,
  targetPhoneNumber,
  label,
  ...props
}) => {
  return (
    <a
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`flex-1 px-4 py-2 text-base font-medium text-white capitalize bg-gradient-to-r from-primary-800 to-primary-700 rounded-md hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500 transition-opacity flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      href={`tel:${targetPhoneNumber}`}
      {...props}
    >
      {label}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        {' '}
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
        />{' '}
      </svg>
    </a>
  )
}
